import { useEffect, useState } from "react";
import api from "../../lib/api";
import { History } from "lucide-react";

export default function ActivityAdmin() {
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        api.get("/admin/audit").then((r) => setLogs(r.data));
    }, []);

    return (
        <div data-testid="admin-activity">
            <h1 className="font-serif text-3xl text-blue-50">History</h1>
            <p className="mt-1 text-sm text-slate-300/55">
                A running history of who changed what.
            </p>

            <div className="mt-8 rounded-2xl border border-blue-500/15 bg-[#0c172e] p-2">
                {logs.length === 0 && (
                    <p className="px-4 py-6 text-sm text-slate-300/45">
                        No activity recorded yet.
                    </p>
                )}
                {logs.map((l) => (
                    <div
                        key={l.id}
                        className="flex items-start gap-3 border-b border-blue-500/10 px-4 py-3.5 last:border-b-0"
                    >
                        <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-500/12 ring-1 ring-blue-500/25">
                            <History className="h-4 w-4 text-blue-400" />
                        </span>
                        <div className="flex-1">
                            <p className="text-sm text-slate-300/85">
                                <span className="font-semibold text-sky-400">
                                    {l.actor_email}
                                </span>{" "}
                                {l.action}
                                {l.entity_title ? (
                                    <span className="text-slate-300/60">
                                        {" "}
                                        — {l.entity_title}
                                    </span>
                                ) : null}
                            </p>
                            <p className="mt-0.5 text-xs text-slate-300/40">
                                {new Date(l.timestamp).toLocaleString()} ·{" "}
                                {l.entity_type}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
